import { useNavigate } from 'react-router-dom';

import { trackEvent } from '../analytics/posthog';
import { GREETERS } from '../home/first-run';
import { PersonaAvatar } from '../persona/persona-avatar';

/**
 * Home with nothing in it yet, for somebody past the first-visit welcome:
 * four of the faces they'll meet, and the one way to start.
 */
export function EmptyRooms() {
  const navigate = useNavigate();
  return (
    <section className="mx-auto mt-16 flex max-w-sm flex-col items-center text-center">
      <div aria-hidden="true" className="flex">
        {GREETERS.map((greeter, index) => (
          <PersonaAvatar
            className={index === 0 ? '' : '-ml-3'}
            key={greeter.name}
            persona={{
              accent: 0,
              avatarProfile: greeter.profile,
              id: `empty-${greeter.name}`,
              name: greeter.name,
            }}
            size="stack"
          />
        ))}
      </div>
      <h2 className="!mt-5 !mb-0 !text-page-title !font-bold !tracking-tight !text-text-primary">
        Create your first room
      </h2>
      <p className="mt-3 max-w-[328px] text-ui-lg text-text-secondary">
        Add a page link and get feedback from AI personas.
      </p>
      <button
        className="mt-6 flex h-[50px] cursor-pointer items-center rounded-button bg-brand px-6 text-ui-lg font-bold text-white transition hover:bg-brand-alt active:scale-[0.98]"
        onClick={() => {
          trackEvent('new_room_clicked', { from: 'empty_state' });
          void navigate('/new');
        }}
        type="button"
      >
        Create a room
      </button>
    </section>
  );
}
